export const LOGIN_REDIRECT = 'LOGIN_REDIRECT';
